import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const poisApiRoutes = {
    activeRoute: apiDataManagerBaseURL + "pointsofinterest/active/",
};

export class PointOfInterestAPI {
    static list(countyEdition) {
        const listUrl = `${poisApiRoutes.activeRoute}${countyEdition}`;

        return API.authenticatedRequest({
            url: listUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listByProvider() {
        const listUrl = `${poisApiRoutes.activeRoute}`;

        return API.authenticatedRequest({
            url: listUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(countyEdition, poi) {
        const createUrl = `${poisApiRoutes.activeRoute}${countyEdition}`;

        return API.authenticatedRequest({
            url: createUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(poi)
        });
    }

    static createByProvider(poi) {
        const createUrl = `${poisApiRoutes.activeRoute}`;

        return API.authenticatedRequest({
            url: createUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(poi)
        });
    }

    static update(countyEdition, id, poi) {
        const updateUrl = `${poisApiRoutes.activeRoute}${countyEdition}/${id}`;

        return API.authenticatedRequest({
            url: updateUrl,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(poi)
        });
    }

    static updateByProvider(id, poi) {
        const updateUrl = `${poisApiRoutes.activeRoute}${id}`;

        return API.authenticatedRequest({
            url: updateUrl,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(poi)
        });
    }

    static delete(countyEdition, id) {
        const deleteUrl = `${poisApiRoutes.activeRoute}${countyEdition}/${id}`;

        return API.authenticatedRequest({
            url: deleteUrl,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteByProvider(id) {
        const deleteUrl = `${poisApiRoutes.activeRoute}${id}`;

        return API.authenticatedRequest({
            url: deleteUrl,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/PointOfInterestAPI.js